export default __webpack_public_path__ + "static/media/LAS0990.34I-43103_-25769_0.2cd3ceb9.jpg";